import LocationNotifier from './location-notifier';
export default LocationNotifier;
